import { render, staticRenderFns } from "./StepCensus.vue?vue&type=template&id=4e1c69f2&scoped=true"
import script from "./StepCensus.vue?vue&type=script&lang=ts"
export * from "./StepCensus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1c69f2",
  null
  
)

export default component.exports